import { React, useState, useEffect } from "react";
import {
  RightLayoutContainer,
  DownArrowDraw,
  DetailFields,
  GroupTitle,
  PageTitleComp,
} from "../../styledElements";
import {
  Button,
  Row,
  Col,
  Form,
  Select,
  Input,
  PageHeader,
  Radio,
  Checkbox,
  Collapse,
} from "antd";
import CollapsePanel from "antd/lib/collapse/CollapsePanel";
import Iconmoon from "../../../Components/IconsFiles/icon";
import { HaberForm } from "../../styledElements";
import { Link, useLocation, useSearchParams } from "react-router-dom";
import {
  updateUserData,
  getUserData,
} from "../../../Services/loginServices";
import { getWorkflowSettings } from "../../../Services/workFlowSettingsServices";
import { useUserNameValidation } from "../../../hooks/useUserNameValidation";
import { useEmailValidation } from "../../../hooks/useEmailValidation";
import { useNavigate } from "react-router";
import AlertContainer from "../../../Components/AlertBoxes/alertBox";
import alertRed from "../../../Assets/Icons/alertRed.svg";
import alertGreen from "../../../Assets/Icons/alertGreen.svg";
import ConfirmationModal from "../../../Components/Modal/ConfirmationModal";
import warning from "../../../Assets/Icons/warning.png";
import { getAllRoles } from "../../../Services/notifications&rolesServices";

const validateMessages = {
  required: "This field is required !",
  types: {
    email: "Email format is invalid !",
  },
};

const { Option } = Select;

const userStatusData = [
  { label: "Active", value: "active" },
  { label: "Disabled", value: "disabled" },
];

const AppUserData = (props) => {
  let [searchParams] = useSearchParams();
  const [alert, setAlert] = useState(false);
  const [warningMsg, setWarningMsg] = useState();
  const [message, setMessage] = useState();
  const location = useLocation();
  const [visible, setVisible] = useState(false);
  const [email, setEmail] = useState(
    location.state ? location.state.email : searchParams.get("email")
  );
  // Username Validation conditions
  const [username, setUser] = useState();
  const [userEditEmail, setUserEditEmail] = useState(false);
  const setUserName = (event) => {
    event.preventDefault();
    setUser(event.target.value);
  };
  const [userTypeData,setUserTypeData] = useState([]);
  const [collapseActiveKeys, setCollapseActiveKeys] = useState({});
  const [form] = Form.useForm();
  const navigate = useNavigate();

  // Hooks for username and Email validation: Disable-enable feature of 'save' button
  const [userIsAlphaNumeric, userValidLength] = useUserNameValidation(username);
  const emailValidation = useEmailValidation(userEditEmail);

  const [userDetails, setUserDetails] = useState();
  const [userStatus, setUserStatus] = useState();
  const [orderManagementSettings,setOrderMangementSettings] = useState();

    const notificationData = [
    {
      id: 1,
      name: "Orders",
      text: "User access to order management can be controlled here",
      options: [
        {
          name: "Requests",
          options: ["Order Approval Request"],
        },
        {
          name: "Confirmations",
          options: [
            "Order Approval Confirmation",
            "Order Rejection Alert",
            "Priority Flag Notification",
          ],
        },
      ],
    },
    {
      id: 2,
      name: "Job Cards",
      text: "User access to job card management can be controlled here",
      options: [
        {
          name: "Requests",
          options: ["Job Card Approval Request"],
        },
        {
          name: "Confirmations",
          options: [
            "Job Card Approval Confirmation",
            "Job Card Completion Confirmation",
            "Job Card Resubmitted for Approval",
          ],
        },
        {
          name: "Rejections",
          options: ["Job Card Rejection Alert", "Job Card Cancellation Alert"],
        },
      ],
    },
    // {
    //   id: 3,
    //   name: "Warehouse",
    //   text: "User access to warehouse operations can be controlled here",
    //   options: [
    //     {
    //       name: "Alerts",
    //       options: [
    //         "Stock Allocation Failure",
    //         "Stock Threshold Alert",
    //         "Location Capacity Breach",
    //       ],
    //     },
    //     {
    //       name: "Confirmations",
    //       options: ["Stock Movement Confirmation"],
    //     },
    //     {
    //       name: "Requests",
    //       options: ["Addition/Deletion of Warehouse Location"],
    //     },
    //   ],
    // },
    {
      id: 4,
      name: "System",
      text: "System-level notifications can be controlled here",
      options: [
        {
          name: "Alerts",
          options: [
            "Error during Save/Submission",
            "Failure of Fetch Orders",
            "Machine Inactive",
          ],
        },
        {
          name: "Confirmations",
          options: ["Bulk Upload of Orders Confirmation"],
        },
      ],
    },
  ];

  const handleStatusChange = (e) => {
    setUserStatus(e.target.value);
  };

  const handleUserChange = (value) => {
    let fieldsValue= {};
    
    switch(value){
      case "ADMIN":
        fieldsValue = {
          job_card_approval_confirmation_email: true,
          job_card_approval_confirmation_in_app: true,
          job_card_completion_confirmation_email: true,
          job_card_completion_confirmation_in_app: true,
          job_card_resubmitted_for_approval_email: true,
          job_card_resubmitted_for_approval_in_app: true,
          job_card_cancellation_alert_email: true,
          job_card_cancellation_alert_in_app: true,
          job_card_rejection_alert_email: true,
          job_card_rejection_alert_in_app: true,
          job_card_approval_request_email: true,
          job_card_approval_request_in_app: true,
          order_approval_confirmation_email: false,
          order_approval_confirmation_in_app: false,
          order_rejection_alert_email: false,
          order_rejection_alert_in_app: false,
          priority_flag_notification_email: true,
          priority_flag_notification_in_app: true,
          order_approval_request_email: false,
          order_approval_request_in_app: false,
          "error_during_save/submission_email": true,
          "error_during_save/submission_in_app": true,
          failure_of_fetch_orders_email: true,
          failure_of_fetch_orders_in_app: true,
          machine_inactive_email: true,
          machine_inactive_in_app: true,
          bulk_upload_of_orders_confirmation_email: true,
          bulk_upload_of_orders_confirmation_in_app: true,
        };
        break;
      case "SALES COORDINATOR":
        fieldsValue = {
          job_card_approval_confirmation_email: true,
          job_card_approval_confirmation_in_app: true,
          job_card_completion_confirmation_email: true,
          job_card_completion_confirmation_in_app: true,
          job_card_resubmitted_for_approval_email: true,
          job_card_resubmitted_for_approval_in_app: true,
          job_card_cancellation_alert_email: false,
          job_card_cancellation_alert_in_app: false,
          job_card_rejection_alert_email: false,
          job_card_rejection_alert_in_app: false,
          job_card_approval_request_email: true,
          job_card_approval_request_in_app: true,
          order_approval_confirmation_email: false,
          order_approval_confirmation_in_app: false,
          order_rejection_alert_email: false,
          order_rejection_alert_in_app: false,
          priority_flag_notification_email: false,
          priority_flag_notification_in_app: false,
          order_approval_request_email: false,
          order_approval_request_in_app: false,
          ["error_during_save/submission_email"]: true,
          ["error_during_save/submission_in_app"]: true,
          failure_of_fetch_orders_email: true,
          failure_of_fetch_orders_in_app: true,
          machine_inactive_email: true,
          machine_inactive_in_app: true,
          bulk_upload_of_orders_confirmation_email: false,
          bulk_upload_of_orders_confirmation_in_app: false,
        };
        break;
      case "PLANT OPERATOR":
        fieldsValue = {
          job_card_approval_confirmation_email: true,
          job_card_approval_confirmation_in_app: true,
          job_card_completion_confirmation_email: true,
          job_card_completion_confirmation_in_app: true,
          job_card_resubmitted_for_approval_email: true,
          job_card_resubmitted_for_approval_in_app: true,
          job_card_cancellation_alert_email: true,
          job_card_cancellation_alert_in_app: true,
          job_card_rejection_alert_email: true,
          job_card_rejection_alert_in_app: true,
          job_card_approval_request_email: false,
          job_card_approval_request_in_app: false,
          order_approval_confirmation_email: false,
          order_approval_confirmation_in_app: false,
          order_rejection_alert_email: false,
          order_rejection_alert_in_app: false,
          priority_flag_notification_email: true,
          priority_flag_notification_in_app: true,
          order_approval_request_email: false,
          order_approval_request_in_app: false,
          ["error_during_save/submission_email"]: true,
          ["error_during_save/submission_in_app"]: true,
          failure_of_fetch_orders_email: true,
          failure_of_fetch_orders_in_app: true,
          machine_inactive_email: true,
          machine_inactive_in_app: true,
          bulk_upload_of_orders_confirmation_email: false,
          bulk_upload_of_orders_confirmation_in_app: false,
        };
        break;
      case "DECKLE PLANNER":
        fieldsValue = {
          job_card_approval_confirmation_email: true,
          job_card_approval_confirmation_in_app: true,
          job_card_completion_confirmation_email: true,
          job_card_completion_confirmation_in_app: true,
          job_card_resubmitted_for_approval_email: true,
          job_card_resubmitted_for_approval_in_app: true,
          job_card_cancellation_alert_email: false,
          job_card_cancellation_alert_in_app: false,
          job_card_rejection_alert_email: false,
          job_card_rejection_alert_in_app: false,
          job_card_approval_request_email: true,
          job_card_approval_request_in_app: true,
          order_approval_confirmation_email: false,
          order_approval_confirmation_in_app: false,
          order_rejection_alert_email: false,
          order_rejection_alert_in_app: false,
          priority_flag_notification_email: true,
          priority_flag_notification_in_app: true,
          order_approval_request_email: false,
          order_approval_request_in_app: false,
          ["error_during_save/submission_email"]: true,
          ["error_during_save/submission_in_app"]: true,
          failure_of_fetch_orders_email: true,
          failure_of_fetch_orders_in_app: true,
          machine_inactive_email: true,
          machine_inactive_in_app: true,
          bulk_upload_of_orders_confirmation_email: false,
          bulk_upload_of_orders_confirmation_in_app: false,
        };
        break;
    }
    form.setFieldsValue(fieldsValue);
  };

  // const setBasicUserRoles = () => {
  //   form.setFieldsValue({
  //     user_management: [],
  //   });
  //   // console.log("role", form.getFieldValue("user_management"));
  // };

  const fetchUserData = async () => {
    try {
      const userData = await getUserData(email);
      setUserDetails(userData);
      setUser(userData.data.name);
      setUserEditEmail(userData.data.email);
      const notification_config = userData.data.notification_config;
      form.setFieldsValue({
        job_card_approval_confirmation_email:
            notification_config?.jobcard.confirmations?.jobcard_approval?.email,
          job_card_approval_confirmation_in_app:
            notification_config?.jobcard.confirmations?.jobcard_approval?.in_app,
          job_card_completion_confirmation_email:
            notification_config?.jobcard?.confirmations?.jobcard_completion?.email,
          job_card_completion_confirmation_in_app:
            notification_config?.jobcard?.confirmations?.jobcard_completion?.in_app,
          job_card_resubmitted_for_approval_email:
            notification_config?.jobcard?.confirmations?.jobcard_resubmitted?.email,
          job_card_resubmitted_for_approval_in_app:
            notification_config?.jobcard?.confirmations?.jobcard_resubmitted.in_app,
          job_card_cancellation_alert_email:
            notification_config?.jobcard?.rejections?.jobcard_cancellation_alert?.email,
          job_card_cancellation_alert_in_app:
            notification_config?.jobcard?.rejections?.jobcard_cancellation_alert?.in_app,
          job_card_rejection_alert_email:
            notification_config?.jobcard?.rejections?.jobcard_rejection_alert?.email,
          job_card_rejection_alert_in_app:
            notification_config?.jobcard?.rejections?.jobcard_rejection_alert?.in_app,
          job_card_approval_request_email:
            notification_config?.jobcard?.requests?.jobcard_approval?.email,
          job_card_approval_request_in_app:
            notification_config?.jobcard?.requests?.jobcard_approval?.in_app,
          order_approval_confirmation_email:
            notification_config?.orders?.confirmations?.order_approval?.email,
          order_approval_confirmation_in_app:
            notification_config?.orders?.confirmations?.order_approval.in_app,
          order_rejection_alert_email:
            notification_config?.orders?.confirmations?.order_rejection_alert?.email,
          order_rejection_alert_in_app:
            notification_config?.orders?.confirmations?.order_rejection_alert?.in_app,
          priority_flag_notification_email:
            notification_config?.orders?.confirmations?.priority_flag_notification?.email,
          priority_flag_notification_in_app:
            notification_config?.orders?.confirmations?.priority_flag_notification?.in_app,
          order_approval_request_email:
            notification_config?.orders?.requests?.order_approval?.email,
          order_approval_request_in_app:
            notification_config?.orders?.requests?.order_approval?.in_app,
          "error_during_save/submission_email":
            notification_config?.system?.alerts?.error_during_save?.email,
          "error_during_save/submission_in_app":
            notification_config?.system?.alerts?.error_during_save?.in_app,
          failure_of_fetch_orders_email:
            notification_config?.system?.alerts?.fetch_orders_failure?.email,
          failure_of_fetch_orders_in_app:
            notification_config?.system?.alerts?.fetch_orders_failure?.in_app,
          machine_inactive_email:
            notification_config?.system?.alerts?.inactive_machine?.email,
          machine_inactive_in_app:
            notification_config?.system?.alerts?.inactive_machine?.in_app,
          bulk_upload_of_orders_confirmation_email:
            notification_config?.system?.confirmations?.bulk_action?.email,
          bulk_upload_of_orders_confirmation_in_app:
            notification_config?.system?.confirmations?.bulk_action?.in_app,
      })
      const orderMangSettings = await getWorkflowSettings("order_management");
      setOrderMangementSettings(orderMangSettings)
    } catch (error) {
      console.log(error);
    }
  };

  const showCancelModal = () => {
    setVisible(true);
  };

  const closeCancelModal = () => {
    setVisible(false);
  };

  const confirmCancelModal = () => {
    form.resetFields();
    setVisible(false);
    navigate("../user-management");
  };

  const handleCollapseChange = (notifId, key) => {
    const keys = Array.isArray(key) ? key.map(String) : key == null ? [] : [String(key)];
    setCollapseActiveKeys((prev) => ({ ...prev, [notifId]: keys }));
  };

  const onHandleCancel = () => {
    showCancelModal();
  };

  const onHandleSave = () => {
    form.submit();
  };

  const onFinish = async (values) => {
    const body = {
      email: values.email,
      name: values.userName,
      role_type: values.role_type.toUpperCase().replaceAll(" ","_"),
      status: values.status,
      notification_config: {
        jobcard:{
          confirmations:{
            jobcard_approval: {
              email: values?.job_card_approval_confirmation_email,
              in_app: values?.job_card_approval_confirmation_in_app
            },
            jobcard_completion: {
              email: values?.job_card_completion_confirmation_email,
              in_app: values?.job_card_completion_confirmation_in_app
            },
            jobcard_resubmitted: {
              email: values?.job_card_resubmitted_for_approval_email,
              in_app: values?.job_card_resubmitted_for_approval_in_app
            }
          },
          rejections:{
            jobcard_cancellation_alert:{
              email: values?.job_card_cancellation_alert_email,
              in_app: values?.job_card_cancellation_alert_in_app
            },
            jobcard_rejection_alert:{
              email: values?.job_card_rejection_alert_email,
              in_app: values?.job_card_rejection_alert_in_app
            }
          },
          requests:{
            jobcard_approval:{
              email: values?.job_card_approval_request_email,
              in_app: values?.job_card_approval_request_in_app
            }
          }
        },
        orders:{
          confirmations:{
            order_approval:{
              email: values?.order_approval_confirmation_email,
              in_app: values?.order_approval_confirmation_in_app
            },
            order_rejection_alert:{
              email: values?.order_rejection_alert_email,
              in_app: values?.order_rejection_alert_in_app
            },
            priority_flag_notification:{
              email: values?.priority_flag_notification_email,
              in_app: values?.priority_flag_notification_in_app
            }
          },
          requests:{
            order_approval:{
              email: values?.order_approval_request_email,
              in_app: values?.order_approval_request_in_app
            }
          }    
        },
        system:{
          alerts:{
            error_during_save:{
              email: values['error_during_save/submission_email'],
              in_app: values['error_during_save/submission_in_app']
            },
            fetch_orders_failure:{
              email: values?.failure_of_fetch_orders_email,
              in_app: values?.failure_of_fetch_orders_in_app
            },
            inactive_machine:{
              email: values?.machine_inactive_email,
              in_app: values?.machine_inactive_in_app
            }
          },
          confirmations:{
            bulk_action:{
              email: values?.bulk_upload_of_orders_confirmation_email,
              in_app: values?.bulk_upload_of_orders_confirmation_in_app
            }
          }
        }
      }
      // roles: {
      //   approve_jobcards: {
      //     edit: values.approve_jobcards?.includes("approve"),
      //     view: values.approve_jobcards?.includes("approve"),
      //   },
      //   approve_orders: {
      //     edit: values.approve_orders?.includes("approve"),
      //     view: values.approve_orders?.includes("approve"),
      //   },
      //   global_settings: accessControlValue(values.global_settings),
      //   machine_records: accessControlValue(values.machine_records),
      //   product_records: accessControlValue(values.product_records),
      //   customer_records: accessControlValue(values.customer_records),
      //   workflow_settings: accessControlValue(values.workflow_settings),
      //   advanced_settings: accessControlValue(values.advanced_settings),
      //   order_records: accessControlOrderRecordCheck(values.order_records, "" ,values.approve_orders),
      //   job_cards: accessControlValue(values.job_cards, "" ,values.approve_jobcards),
      //   company_profile: accessControlValue(values.company_profile),
      //   user_management: accessControlValue(values.user_management),
      //   plan_details_and_billing: accessControlValue(
      //     values.plan_details_and_billing
      //   ),
      //   production: {
      //     job_cards: accessControlValue(values.production_job_cards),
      //     jumbo_reels: accessControlValue(values.jumbo_reels),
      //     prod_details: accessControlValue(values.prod_details,"productionDetails"),
      //   },
      //   packaging_config: accessControlValue(values.packaging_config),
      //   inventory: {
      //     stocks: accessControlValue(values.stocks),
      //   },
      // },
    };
    try {
      const inviteNewUserResponse = await updateUserData(body);
      console.log("new user invite response", inviteNewUserResponse.to);
      // setAlert(true);
      setWarningMsg(false);
      //setMessage(inviteNewUserResponse.data.msg);
      // setMessage("User updated successfully");
      setTimeout(() => {
        navigate("/organization-setting/user-management",{
          state: { response: inviteNewUserResponse }
        });
      }, 10);
    } catch (error) {
      setAlert(true);
      setWarningMsg(true);
      setMessage("Error while updating user");
    }
  };

  useEffect(() => {
    const fetchRoles = async () => {
      try{
        const roles=await getAllRoles();
        setUserTypeData(roles.map(role=>role.name.replaceAll("_"," ")));
      }
      catch(e)
      {
        console.log(e);
      }
    };
    fetchRoles();
    fetchUserData();
  }, []);

  return userDetails ? (
    <Form>
      {alert ? (
        <AlertContainer
          color={warningMsg ? "red" : "green"}
          icon={warningMsg ? alertRed : alertGreen}
          msg={message}
        />
      ) : (
        ""
      )}
      <RightLayoutContainer>
        <PageTitleComp>
          <PageHeader
            ghost={false}
            title="Edit User"
            extra={[
              <Button key="3" className="textTypeBtn" onClick={onHandleCancel}>
                Cancel changes
              </Button>,
              <Button
                key="2"
                className="themeBtn"
                disabled={
                  !(userIsAlphaNumeric && userValidLength && emailValidation)
                }
                onClick={onHandleSave}
              >
                <Iconmoon icon="addcircle" size={14} color="#ffffff" />
                Save
              </Button>,
            ]}
          ></PageHeader>
        </PageTitleComp>
        <DetailFields>
          {/* {console.log("userDetails", userDetails)} */}
          {userDetails ? (
            <HaberForm>
              <div className="groupDetailWrap">
                <Form
                  form={form}
                  name="basic"
                  autoComplete="off"
                  className="haberLogin"
                  onFinish={onFinish}
                  onFinishFailed={(error) => {
                    console.log("Form Error", error);
                  }}
                  initialValues={{
                    remember: true,
                  }}
                  validateMessages={validateMessages}
                >
                  <Row gutter={[16, 16]} className="groupForm">
                    <Col span={8}>
                      <GroupTitle>
                        <h2>General Details</h2>
                        <p>Enter general details of the user</p>
                      </GroupTitle>
                    </Col>
                    <Col span={16}>
                      <Row className="centerAlign">
                        <Col span={12}>
                          <div className="boxFieldTitle">
                            <label>User Name</label>
                            <p>
                              Your business will be identified using this name
                            </p>
                          </div>
                        </Col>
                        <Col span={12}>
                          <div className="boxFormType">
                            <Form.Item
                              initialValue={userDetails?.data?.name}
                              name="userName"
                              rules={[
                                { required: true },
                                {
                                  min: 3,
                                  message:
                                    "Minimum 3 and maximum 50 characters are required",
                                },
                                {
                                  max: 50,
                                  message:
                                    "Minimum 3 and maximum 50 characters are required",
                                },
                                {
                                  validator: () => {
                                    if (userIsAlphaNumeric)
                                      return Promise.resolve();
                                    else
                                      return Promise.reject(
                                        "Only alphanumeric characters are allowed"
                                      );
                                  },
                                },
                              ]}
                              className=""
                            >
                              <Input
                                placeholder="Enter your name"
                                style={{ textTransform: "capitalize" }}
                                onChange={setUserName}
                              />
                            </Form.Item>
                          </div>
                        </Col>
                      </Row>

                      <Row className="centerAlign">
                        <Col span={12}>
                          <div className="boxFieldTitle">
                            <label>Email Address</label>
                            <p>User can login using this email address</p>
                          </div>
                        </Col>
                        <Col span={12}>
                          <div className="boxFormType">
                            <Form.Item
                              name="email"
                              rules={[{ required: true }, { type: "email" }]}
                              className=""
                              initialValue={userDetails?.data?.email}
                            >
                              <Input
                                placeholder="Enter your email"
                                disabled={true}
                                // onChange={(e) => {
                                //   setUserEditEmail(e.target.value);
                                // }}
                              />
                            </Form.Item>
                          </div>
                        </Col>
                      </Row>
                      <Row className="centerAlign">
                        <Col span={12}>
                          <div className="boxFieldTitle">
                            <label>Role Type</label>
                            <p>User will have selected role</p>
                          </div>
                        </Col>
                        <Col span={12}>
                          <div className="boxFormType">
                            <Form.Item
                              name="role_type"
                              className=""
                              initialValue={userDetails?.data?.role_type.replaceAll("_"," ")}
                            >
                              <Select
                                suffixIcon={<DownArrowDraw />}
                                onChange={handleUserChange}
                              >
                                {userTypeData.map((userType) => (
                                  <Option key={userType}>
                                    {userType}
                                  </Option>
                                ))}
                              </Select>
                            </Form.Item>
                          </div>
                        </Col>
                      </Row>
                      <Row className="centerAlign">
                        <Col span={12}>
                          <div className="boxFieldTitle">
                            <label>User Status</label>
                            <p>
                              User can access to Kaiznn only if it{"'"}s set to active
                            </p>
                          </div>
                        </Col>
                        <Col span={12}>
                          <div
                            className="boxFormType switchRadio"
                            style={{
                              justifyContent: "flex-end",
                              display: "flex",
                            }}
                          >
                            <Form.Item
                              name="status"
                              className=""
                              initialValue={userDetails?.data?.status}
                            >
                              <Radio.Group
                                options={userStatusData}
                                onChange={handleStatusChange}
                                optionType="button"
                                buttonStyle="solid"
                              />
                            </Form.Item>
                          </div>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                  <Row
                    gutter={[24, 24]}
                    className="groupForm"
                    style={{ borderBottom: "0px" }}
                  >
                    <Col span={8}>
                      <GroupTitle style={{ marginTop: "10px" }}>
                        <h2>Notifications</h2>
                        <p>This user will have access to selected notifications</p>
                      </GroupTitle>
                    </Col>
                  </Row>
                  {notificationData.map((notification) => (
                    <Row gutter={[16, 16]} className="groupForm">
                      <Col span={8}>
                        <GroupTitle>
                          <h2>{notification.name}</h2>
                          <p>{notification.text}</p>
                        </GroupTitle>
                      </Col>
                      <Col span={16}>
                        <Row
                          className="centerAlign titleVCenter paddingTB"
                          style={{ border: "none" }}
                        >
                          <Col span={24}>
                            <Collapse
                              // onChange={onChangeCollpase}
                              expandIconPosition="right"
                              bordered={false}
                              style={{
                                backgroundColor: "white",
                                width: "100%",
                                border: "none",
                              }}
                              activeKey={
                                collapseActiveKeys[notification.id] ??
                                notification.options.map((_, index) => String(index))
                              }
                              onChange={(key) => handleCollapseChange(notification.id, key)}
                            >
                              {notification.options.map((group, groupIndex) => (
                                <CollapsePanel
                                  key={String(groupIndex)}
                                  style={{ width: "100%", border: "none" }}
                                  header={
                                    <div
                                      className="boxFieldTitle"
                                      style={{
                                        width: "100%",
                                        display: "flex",
                                        justifyContent: "space-between",
                                      }}
                                    >
                                      <label>{group.name}</label>
                                    </div>
                                  }
                                  extra={
                                    <Button
                                      className={"textTypeBtn"}
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        group.options.forEach((opt)=>{
                                          form.setFieldsValue({
                                            [`${opt}_in_app`.toLowerCase().replaceAll(" ", "_")]:false,
                                            [`${opt}_email`.toLowerCase().replaceAll(" ", "_")]:false
                                          })
                                        })
                                        setCollapseActiveKeys((prev) => {
                                          const current = prev[notification.id] ?? notification.options.map((_, i) => String(i));
                                          const newKeys = (Array.isArray(current) ? current : [current]).filter(k => k !== String(groupIndex));
                                          return { ...prev, [notification.id]: newKeys };
                                        });
                                      }}
                                    >
                                      Disable all
                                    </Button>
                                  }
                                  forceRender={true}
                                >
                                  <Row span={24}>
                                    <Col span={12}></Col>
                                    <Col span={12}>
                                      <Row span={24}>
                                        <Col span={12}>
                                          <div
                                            className="boxFormType"
                                            style={{
                                              display: "flex",
                                              justifyContent: "center",
                                            }}
                                          >
                                            <span>In App</span>
                                          </div>
                                        </Col>
                                        <Col span={12}>
                                          <div
                                            className="boxFormType"
                                            style={{
                                              display: "flex",
                                              justifyContent: "center",
                                            }}
                                          >
                                            <span>Email</span>
                                          </div>
                                        </Col>
                                      </Row>
                                    </Col>
                                  </Row>

                                  {group.options.map((opt, optIndex) => (
                                    <Row span={24} key={optIndex}>
                                      <Col span={12}>
                                        <div className="boxFieldTitle">
                                          <span>{opt}</span>
                                        </div>
                                      </Col>
                                      <Col span={12}>
                                        <Row span={24}>
                                          <Col span={12}>
                                            <div className="boxFormType reverseCheckbox">
                                              <Form.Item
                                                name={`${opt}_in_app`
                                                  .toLowerCase()
                                                  .replaceAll(" ", "_")}
                                                valuePropName={"checked"}
                                              >
                                                <Checkbox
                                                  onChange={(e) => {
                                                    form.setFieldsValue({
                                                      [`${opt}_in_app`
                                                        .toLowerCase()
                                                        .replaceAll(" ", "_")]:
                                                        e.target.checked,
                                                    });
                                                  }}
                                                  className="flexRowReverse"
                                                />
                                              </Form.Item>
                                            </div>
                                          </Col>
                                          <Col span={12}>
                                            <div className="boxFormType reverseCheckbox">
                                              <Form.Item
                                                name={`${opt}_email`
                                                  .toLowerCase()
                                                  .replaceAll(" ", "_")}
                                                valuePropName="checked"
                                              >
                                                <Checkbox
                                                  onChange={(e) => {
                                                    form.setFieldsValue({
                                                      [`${opt}_email`
                                                        .toLowerCase()
                                                        .replaceAll(" ", "_")]:
                                                        e.target.checked,
                                                    });
                                                  }}
                                                  className="flexRowReverse"
                                                />
                                              </Form.Item>
                                            </div>
                                          </Col>
                                        </Row>
                                      </Col>
                                    </Row>
                                  ))}
                                </CollapsePanel>
                              ))}
                            </Collapse>
                          </Col>
                        </Row>
                        {/* <Row className="centerAlign titleVCenter paddingTB">
                          <Col span={24}>
                            <Collapse
                              // onChange={onChangeCollpase}
                              expandIconPosition="right"
                              bordered={false}
                              style={{ backgroundColor: "white", width: "100%" }}
                            ></Collapse>
                          </Col>
                        </Row> */}
                      </Col>
                    </Row>
                  ))}
                </Form>
              </div>
            </HaberForm>
          ) : (
            ""
          )}
        </DetailFields>

        <ConfirmationModal
          visible={visible}
          icon={warning}
          confirmAction={confirmCancelModal}
          cancelAction={closeCancelModal}
        >
          <span>Are you sure?</span>
          <p>
            You have pending changes on this page, are you sure you want to
            leave?
          </p>
        </ConfirmationModal>
      </RightLayoutContainer>
    </Form>
  ) : (
    <></>
  );
};

export default AppUserData;
